export const hasName = 'hasName';
export const hasDescription = 'hasDescription';

export const hasNamePath = [hasName, 'value_text'];
export const hasDescriptionPath = [hasDescription, 'value_text'];
